module.exports = __webpack_public_path__ + "img/annotate.95efb003.gif";